<template>
  <b-card
    :header="$t('account.email')"
    bg-variant="light"
    class="border-0"
    header-class="border-0"
  >
    <item
      v-for="(item, index) in model"
      :key="item.id"
      :ref="`item${index}`"
      :value="item"
      @remove="remove"
    />

    <b-btn
      size="sm"
      variant="primary"
      :title="$t('shared.add')"
      v-b-tooltip
      @click="add"
    >
      <font-awesome-icon icon="plus" fixed-width class="align-middle"/>
    </b-btn>
  </b-card>
</template>

<script>
import Item from './Item'

export default {
  name: 'Emails',
  components: {
    Item
  },
  props: {
    value: Array
  },
  computed: {
    model:{
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    add () {
      const item = {
        id: -String(Math.floor(Math.random() * 99999999)),
        type: 'work',
        value: null
      }
      this.model.push(item)
    },
    remove (itemId) {
      this.model = this.model.filter(i => i.id !== itemId)
    },
    validateAll () {
      const validates = this.model.map((item, i) => this.$refs[`item${i}`][0].validateAll())
      return Promise.all(validates).then(all => {
        return all.every(v => v)
      })
    }
  }
}
</script>
